<template>
  <div class="h-full p-20px">
    <div class="flex flex-column h-full">
      <Tabs :datas="{'现金':'现金日记账','银行存款':'银行日记账'}" v-model="ioType" class="bg-white-color px-16px"/>
      <vxe-toolbar class-name="px-16px" :loading="loading">
        <template #buttons>
          <Button :disabled="!account" color="green" class="mr-16px" icon="fa fa-edit" @click="showForm()">记账</Button>
          <Select :datas="accountList" keyName="id" titleName="name" type="object" v-model="account" style="min-width: 200px;margin-right: 16px" :deletable="false">
            <template #show="{value}">{{ value.code }} - {{ value.name }}</template>
            <template #item="{item}">{{ item.code }} - {{ item.name }}</template>
          </Select>
          <!-- <DropdownCustom ref="journalParamsDropdown" button class="h-btn-primary" trigger="click">
            <div>{{ startDate }} 至 {{ endDate }}</div> -->
		<DropdownCustom ref="journalParamsDropdown" button class="h-btn-primary" trigger="click">
			<div v-if="startDate!==endDate">{{ fqFormat(startDate) }} 至 {{ fqFormat(endDate) }}</div>
			<div v-else>{{ fqFormat(startDate) }}</div>
            <template #content>
              <Form style="padding: 10px">
				<!-- //jxdq改为和会计一样的期间查询 -->
                <!-- <FormItem class="!pb-5px" label="日期">
                  <div class="flex items-center">
                    <DatePicker v-model="params.start" :clearable="false" :option="{end:params.end}"/>
                    <span class="mx-8px">至</span>
                    <DatePicker v-model="params.end" :clearable="false" :option="{start:params.start}"/>
                  </div>
                </FormItem> -->
				<FormItem class="!pb-5px" label="会计期间">
					<div class="flex items-center">
						<Select @change="dateCheck" v-model="params.start" :deletable="false" filterable :datas="checkoutSelect"/>
						<span class="mx-8px">至</span>
						<Select @change="dateCheck" v-model="params.end" :deletable="false" filterable :datas="checkoutSelect"/>
					</div>
				</FormItem>
                <FormItem class="!pb-5px" label="收支类型">
                  <Select :datas="ioTypeOptions" filterable v-model.id="params.ioTypeId"/>
                </FormItem>
                <!-- <FormItem class="!pb-5px" label="结算方式">
                  <Select :datas="settlementTypeOptions" filterable v-model.number="params.settlementTypeId"/>
                </FormItem> -->
                <FormItem class="!pb-5px" label="项目">
                  <Select :datas="projectOptions" filterable v-model.id="params.projectCategoryDetailsId"/>
                </FormItem>
                <FormItem class="!pb-5px" label="部门">
                  <Select :datas="deptOptions" filterable v-model.id="params.deptCategoryDetailsId"/>
                </FormItem>
                <FormItem class="!pb-5px" label="流水号">
                  <Input v-model="params.code"/>
                </FormItem>
                <FormItem class="!pb-5px" label="往来单位">
				  <Select :datas="assistingAccountingAll" filterable v-model.id="params.accountingCategoryDetailsId"/>
                </FormItem>
                <FormItem class="!pb-5px" label="摘要">
                  <Input v-model="params.digest"/>
                </FormItem>
                <FormItem class="!pb-5px" label="备注">
                  <Input v-model="params.remark"/>
                </FormItem>
                <FormItem class="!pb-10px" label="金额">
                  <div class="flex items-center">
                    <NumberInput v-model="params.minMoney"/>
                    <span class="mx-8px">至</span>
                    <NumberInput v-model="params.maxMoney"/>
                  </div>
                </FormItem>
                <FormItem class="!pb-5px">
                  <Button color="primary" @click="loadList();" :loading="loading">确定</Button>
                  <Button @click="journalParamsDropdown.hide()">取消</Button>
                  <Button @click="reset()">重置</Button>
                </FormItem>
              </Form>
            </template>
          </DropdownCustom>
        </template>
        <template #tools>
          <Checkbox v-model="showAll" class="mr-16px">显示全部</Checkbox>
		  <Button icon="h-icon-refresh" color="yellow" @click="loadList();loadAccountList();loadAccountingCategory();loadCashierIoType();">刷新</Button>
		  <Button icon="fa fa-print" @click="printList">打印</Button>
          <!-- <DropdownMenu
              button
              trigger="hover"
              @clickItem="printClickItem"
              :datas="{printBill:'打印凭据',printList:'打印列表'}">
            打印
          </DropdownMenu> -->
          <Button @click="importJournal" :disabled="!account">导入</Button>
          <Button @click="importJournal" :disabled="!account">模板导入</Button>
          <Button @click="importJournalWithMapping" :disabled="!account">银行对账单导入</Button>
		  <!-- 批量操作只需要保留删除，指定类别 -->
		  <!-- :datas="{batchDelete:'批量删除',setIoType:'指定收支类别',setAccountingCategory:'指定往来单位',setProject:'指定项目',setDept:'指定部门'}"> -->
          <DropdownMenu
              button
              trigger="hover"
              @clickItem="batchClickItem"
              :datas="{batchDelete:'批量删除',setIoType:'指定收支类别',setAccountingCategory:'指定往来单位',setProject:'指定项目',setDept:'指定部门'}">
            批量操作
          </DropdownMenu>
          <DropdownMenu
              button
              trigger="hover"
              class="h-btn-primary"
              @clickItem="voucherClickItem"
              :datas="{generatePreview:'生成凭证预览',generateSettings:'生成凭证设置'}">
            生成凭证
          </DropdownMenu>
        </template>
      </vxe-toolbar>
      <div class="flex-1 h-0px">
        <vxe-table ref="journalTable"
                   :checkbox-config="{visibleMethod: ({ row }) => !row.cashierTransferId && !row.init,checkMethod:({ row }) => !row.cashierTransferId && !row.init}"
                   :loading="loading"
                   :data="dataResult.results"
                   height="auto"
                   border>
          <vxe-column type="checkbox" width="50" align="center" fixed="left"/>
          <vxe-column title="交易流水号" field="code" width="160"/>
          <vxe-column title="日记账序号" field="serialNumber" width="160">
            <template #default="{row}">
              <div @click="showEvidence(row)" class="text-hover primary-color">{{ row.serialNumber }}</div>
            </template>
          </vxe-column>
          <vxe-column title="日期" field="billDate" width="120"/>
          <vxe-column title="摘要" field="digest" width="120"/>
          <vxe-column title="收支类别" field="ioTypeValue" width="120">
            <template #default="{row}">
              <span v-if="row.cashierTransferId">内部转账</span>
              <span v-else>{{ row.ioTypeValue }}</span>
            </template>
          </vxe-column>
          <vxe-column title="往来单位" field="accountingCategoryDetailsValue" width="150"/>


		  <!-- jxd让部门能显示 -->
          <vxe-column title="部门" field="deptName" :visible="showAll" width="100">
			<template #default="{row}">
              <span v-if="row.deptCategoryDetailsId">{{ deptName(row.deptCategoryDetailsId) }}</span>
            </template>
		  </vxe-column>
		  	<!-- jxd让项目能显示 -->
          <vxe-column title="项目" field="projectName" :visible="showAll" width="100">
			<template #default="{row}">
              <span v-if="row.projectCategoryDetailsId">{{ projectName(row.projectCategoryDetailsId) }}</span>
            </template>
		  </vxe-column>


          <!-- <vxe-column title="收入(借方)" field="debit" width="100" align="right"/>
          <vxe-column title="支出(贷方)" field="credit" width="100" align="right"/>
          <vxe-column title="余额" field="balance" width="100" align="right" :show-overflow="false">
            <template #default="{row}">
              <vxe-input class="balance-edit" :disabled="updating" v-model.number="row.balance" v-if="row.init" @blur="initialBalanceChange(row)"/>
              <span v-else>{{ row.balance.toFixed(2) }}</span>
            </template>
          </vxe-column> -->

		  <vxe-column title="收入(借方)" field="debit" width="120" align="right">
				<template #default="{ row }">
					<span>{{ formatCurrency(row.debit) }}</span>
				</template>
			</vxe-column>

			<vxe-column title="支出(贷方)" field="credit" width="120" align="right">
				<template #default="{ row }">
					<span>{{ formatCurrency(row.credit) }}</span>
				</template>
			</vxe-column>

			<vxe-column title="余额" field="balance" width="120" align="right" :show-overflow="false">
				<template #default="{ row }">
					<vxe-input class="balance-edit" :disabled="updating" v-model.number="row.balance" v-if="row.init" @blur="initialBalanceChange(row)" />
					<span v-else>{{ formatCurrency(row.balance) }}</span>
				</template>
			</vxe-column>

          <!-- <vxe-column title="结算方式" field="settlementTypeTitle" width="120" :visible="showAll"/> -->
          <!-- <vxe-column title="票据号" field="billNo" width="120" :visible="showAll"/> -->
		  <!-- jxd就没有这个 -->
		  <vxe-column title="票据号" field="billNo" width="120" :visible="showAll"/>
          <vxe-column title="备注" field="remark" width="120" :visible="showAll"/>
          <vxe-column title="关联凭证" field="voucherCode" width="80" align="center">
            <template #default="{row}">
              <router-link @success="loadList" class="text-hover primary-color" width="1120px"	
                           v-if="row.voucherId"
                           :to="{name:'VoucherForm',params:{voucherId:row.voucherId}}">
                {{ row.voucherCode }}
              </router-link>
            </template>
          </vxe-column>
          <vxe-column title="操作" width="180">
            <template #default="{row}">
              <div class="actions" v-if="!row.init && !row.cashierTransferId">
                <!-- <span v-if="!row.voucherId" @click="showForm(row)" class="fa fa-edit">编辑</span>
                <span v-if="!row.voucherId" @click="doTrash(row)" class="fa fa-trash">删除</span>
				<span @click="showForm(row,'insert')" class="fa fa-trash">插入</span> -->
				<span v-if="!row.voucherId && manba(currentAccountDate).format('YYYY-MM') == row.date" @click="showForm(row)" class="fa fa-edit">编辑</span>
                <span v-if="!row.voucherId && manba(currentAccountDate).format('YYYY-MM') == row.date" @click="doTrash(row)" class="fa fa-trash">删除</span>
				<span v-if="manba(currentAccountDate).format('YYYY-MM') == row.date" @click="showForm(row,'insert')" class="fa fa-trash">插入</span>
              </div>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
      <vxe-pager @page-change="onPageChange"
                 v-model:current-page="page.page"
                 v-model:page-size="page.pageSize"
                 :total="dataResult.total"
                 :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
        <template #left>
          <vxe-button @click="loadList()" type="text" size="mini" icon="fa fa-refresh" :loading="loading"></vxe-button>
        </template>
      </vxe-pager>
    </div>
  </div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */

export default {
	name: "CashierJournal"
}
</script>
<script setup>
import {ref, h, watch, reactive,computed} from "vue";
import manba from "manba";
import {confirm, message} from "heyui.ext";
import {useStore} from 'vuex'
import CashierAccount from "@/api/CashierAccount";
import CashierIoType from "@/api/CashierIoType";
import {layer} from "@layui/layer-vue";
import CashierJournalForm from "@/views/cashier/CashierJournalForm";
import CashierJournal from "@/api/CashierJournal";
import setting from "@/api/setting";
import CashierJournalEvidence from "@/views/cashier/CashierJournalEvidence";
import Qs from "qs";
import CashierJournalBatchUpdate from "@/views/cashier/CashierJournalBatchUpdate";
import CashierIoTypeTemplate from "@/views/cashier/CashierIoTypeTemplate";
import CashierJournalVoucherPreview from "@/views/cashier/CashierJournalVoucherPreview";
import CashierAccountForm from "@/views/cashier/CashierAccountForm";
import CashierImport from "@/views/cashier/CashierImport.vue";
import CashierImportMapping from "@/views/cashier/CashierImportMapping.vue";


const store = useStore();

const checkoutSelect = computed(() => store.getters['checkoutSelect']);

const accountList = ref([]);
const ioTypeMap = reactive({});
const ioTypeOptions = ref([]);
const settlementTypeOptions = ref([]);
const projectOptions = ref([]);
const deptOptions = ref([]);
const account = ref(null);
const journalTable = ref(null);
const journalParamsDropdown = ref(null);
const loading = ref(false);
const ioType = ref('现金');
const assistingAccountingAll = ref([]);
const customers = ref([]);
const suppliers = ref([]);
const employees = ref([]);

const currentAccountDate = manba(store.state.currentAccountSets.currentAccountDate);
const startDate = ref(currentAccountDate.startOf(manba.MONTH).format("YYYY-M"));//jxdq
const endDate = ref(currentAccountDate.endOf(manba.MONTH).format("YYYY-M"));//jxdq

const updating = ref(false);
const showAll = ref(false);


const formatCurrency = (value) =>{
	if (value == null) return '';
	return Number(value).toLocaleString(undefined, {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2
	});
}

const tablePrint = {
        // 自定义打印的样式示例
        style: `
          /* 整个表格的基础样式 */
          .vxe-table {
            font-family: "Microsoft YaHei", 微软雅黑, "MicrosoftJhengHei", 华文细黑, STHeiti, MingLiu; // 设置表格整体字体
          }

          /* 表头单元格 */
          .vxe-table thead th {
            border: 1px solid #000;
            font-size: 14px;
            word-break: break-all;
            overflow-wrap: break-word;
          }

          /* 表体单元格（即数据行的所有单元格） */
          .vxe-body--column, 
          .vxe-table tbody td {
            border: 1px solid #000;
            font-size: 12px;
            word-break: break-all;
            overflow-wrap: break-word;
          }
        `
      }

//jxdin
const ins = (row) => {
	console.log(row)
}

//jxd改page
const page = reactive({
	page: 1,
	pageSize: 20
})

const dataResult = ref({
	results: [],
	total: 20
})

const reset = () =>{
	params.start = startDate.value;
	params.end= endDate.value;
	params.ioTypeId= null;
	params.settlementTypeId= null;
	params.projectCategoryDetailsId= null;
	params.deptCategoryDetailsId= null;
	params.code= null;
	params.minMoney= null;
	params.maxMoney= null;
	params.accountingCategoryDetailsId= null;
	params.digest= null;
	params.remark= null;
}

const params = reactive({
	start: startDate.value,
	end: endDate.value,
	ioTypeId: null,
	settlementTypeId: null,
	projectCategoryDetailsId: null,
	deptCategoryDetailsId: null,
	code: null,
	minMoney: null,
	maxMoney: null,
	accountingCategoryDetailsId: null,
	digest: null,
	remark: null,
});

const deptName = (id) =>{
	const foundObject = deptOptions.value.find(department => department.key === id);
    return foundObject ? foundObject.title : null;  
}

const projectName = (id) =>{
	const foundObject = projectOptions.value.find(department => department.key === id);
    return foundObject ? foundObject.title : null;  
}

const onPageChange = ({currentPage, pageSize}) => {
	console.log(currentPage, pageSize,page)
	page.page = currentPage;
	page.pageSize = pageSize;
	loadList();
}

const dateCheck = () => {
	// 定义开始时间和结束时间
	let startDate = new Date(params.start);
	let endDate = new Date(params.end);
		if(startDate > endDate){
			message({
				type:'warn',
				text: `开始时间必须早于或等于结束时间！`
			});
		}
}

const getLastDayOfMonth = (dateString) => {  
    // 将字符串转换为Date对象  
    const date = new Date(dateString);  
      
    // 确保日期字符串是有效的  
    if (isNaN(date.getTime())) {  
        throw new Error('Invalid date string');  
    }  
      
    // 获取该月份的最后一天  
    let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);  
      
    // 将Date对象转换回字符串形式  
    const year = lastDay.getFullYear();  
    const month = String(lastDay.getMonth() + 1).padStart(2, '0');  
    const day = String(lastDay.getDate()).padStart(2, '0');  
      
    return `${year}-${month}-${day}`;  
};  


const loadAccountList = () => {
	loading.value = true
	CashierAccount.list().then(({data}) => {
		accountList.value = data.filter(val => val.type === ioType.value);
		if (accountList.value.length) {
			account.value = account.value ? accountList.value.find(val => val.id === account.value.id) : accountList.value[0];
		}
	}).finally(() => loading.value = false)
}

loadAccountList();


const loadCashierIoType = () =>{
	CashierIoType.list().then(({data}) => {
		ioTypeOptions.value = data.map(val => {
			ioTypeMap[val.id] = val;
			return {
				key: val.id,
				title: val.type + "-" + val.code + "-" + val.name
			}
		});
	})
}
loadCashierIoType();

setting.accountSets.getSettlementTypeList().then(({data}) => {
	settlementTypeOptions.value = data.map(val => {
		return {
			key: val.id,
			title: val.title
		}
	});
})

const loadAccountingCategory = ()=>{
	setting.accountingCategory.list().then(({data}) => {
		const categorys = (data || []).filter(val => ['部门', '项目','客户','供应商','职员'].includes(val.name));
		if (categorys.length) {
			setting.accountingCategoryDetails.loadAuxiliaryAccountingData(categorys).then(({data}) => {
				let dept = categorys.find(value => value.name === '部门');
				deptOptions.value = data[dept.id].map(val => {
					return {
						key: val.id,
						accountingCategoryId: val.categoryId,//应该是类别id
						title: val.name
					}
				});
				let project = categorys.find(value => value.name === '项目');
				projectOptions.value = data[project.id].map(val => {
					return {
						key: val.id,
						accountingCategoryId: val.categoryId,//应该是类别id
						title: val.name
					}
				});
				let customer = categorys.find(value => value.name === '客户');
				customers.value = data[customer.id].map(val => {
					return {
						key: val.id,
						accountingCategoryId: val.categoryId,//应该是类别id
						title: val.name
					}
				});
				let supplier = categorys.find(value => value.name === '供应商');
				suppliers.value = data[supplier.id].map(val => {
					return {
						key: val.id,
						accountingCategoryId: val.categoryId,//应该是类别id
						title: val.name
					}
				});
				let employee = categorys.find(value => value.name === '职员');
				employees.value = data[employee.id].map(val => {
					return {
						key: val.id,
						accountingCategoryId: val.categoryId,//应该是类别id
						title: val.name
					}
				});
				assistingAccountingAll.value = [...customers.value,...suppliers.value,...employees.value]
				// console.log(assistingAccountingAll)
			})
		}
	})
}
loadAccountingCategory();


const initialBalanceChange = (row) => {
	if(row.billDate > account.value.createDate){
		message.error("非启用时间的期初记录，由系统根据上期自动生成，不能修改")
		loadList()
		return;
	}
	updating.value = true;
	CashierJournal.save({id: row.id, balance: row.balance,accountId:row.accountId}).then(() => {
		loadList();
	}).finally(() => updating.value = false)
}

const loadList = () => {
	let end = getLastDayOfMonth(params.end)
	let parmss = JSON.stringify(params);
	let parmsss = JSON.parse(parmss);
	parmsss.end = end;
	let acrossTheMoon = params.start == params.end ? false : true;
	if (account.value) {
		loading.value = true
		//jxd改page
		CashierJournal.list(account.value.id,page, Object.assign(parmsss)).then(({data}) => {
			//给每行加一个年月的日期格式 用于判断，这行是否能进行编辑，删除，插入操作
			data.results.forEach((item)=>{
				item.date = manba(new Date(item.billDate)).format("YYYY-MM")
			})
			if(page.page == 1 && acrossTheMoon){
				//跨月保留1条期初数据，且是第一页的情况下保留
				for(let i = 1;i < data.results.length ; i++){
					if(data.results[i].init){
						data.results.splice(i,1);
						i--;
					}
				}
			}else if(page.page != 1 && acrossTheMoon){
				console.log("不等于1",data)
				//跨月第二页开始，不保留任何期初
				for(let i = 0;i < data.results.length ; i++){
					if(data.results[i].init){
						data.results.splice(i,1);
						i--;
					}
				}
			}
			dataResult.value = data;
			startDate.value = params.start;
			endDate.value = params.end;
			journalParamsDropdown.value.hide();
		}).finally(() => loading.value = false)
	}
}

const showForm = (entity = null,insert = null) => {
	//jxd插入流水
	if(insert == 'insert'){
		let obj = {};
		obj.id = entity.id;
		obj.billDate = entity.billDate;
		obj.accountSetsId = entity.accountSetsId;
		obj.serialNumber = entity.serialNumber;
		obj.accountId = entity.accountId;
		obj.type = entity.type;
		entity = obj;
	}
	let startDate = currentAccountDate.startOf(manba.MONTH).format();
	let endDate = currentAccountDate.endOf(manba.MONTH).format();
	let layerId = layer.open({
		title: account.value.name + "日记账",
		shadeClose: false,
		closeBtn: false,
		area: ['700px', 'auto'],
		zIndex: 1000,
		content: h(CashierJournalForm, {
			entity, account, startDate, endDate, ioTypeOptions,
			ioTypeMap, settlementTypeOptions, deptOptions, projectOptions,insert,
			onClose: () => {
				layer.close(layerId);
				loadCashierIoType();//更新收支类别
				loadAccountingCategory();//更新辅助核项目新增部门
				loadList();
			},
			onSuccess: () => {
				loadList();
				loadCashierIoType();//更新收支类别
				loadAccountingCategory();//更新辅助核项目新增部门
				layer.close(layerId);
			}
		})
	});
}

const doTrash = (row) => {
	confirm({
		content: `确认删除此记录?`,
		onConfirm: () => {
			loading.value = true;
			CashierJournal.delete(row.id).then(() => {
				loadList();
			}).finally(() => loading.value = false)
		}
	})
}

const showEvidence = (journal) => {
	journal.deptName = deptName(journal.deptCategoryDetailsId);//传明细类别id
	journal.projectName = projectName(journal.projectCategoryDetailsId);
	// console.log(journal)
	layer.open({
		title: journal.serialNumber,
		closeBtn: 2,
		area: ['1000px', 'auto'],
		content: h(CashierJournalEvidence, {
			journal, account: account.value
		})
	});
}

// const printClickItem = (key) => {
// 	let records = journalTable.value.getCheckboxRecords().map(row => row.id);
// 	switch (key) {
// 		case "printBill":
// 			if (records.length) {
// 				window.open("/api/pdf/journal?journal=" + records.join("&journal="))
// 			} else {
// 				message("请选择需要打印的记录~")
// 			}
// 			break
// 		case "printList":
// 			window.open("/api/pdf/journal/list/" + account.value.id + "?" + Qs.stringify(Object.assign(params, page.value)))
// 			break
// 	}
// }
const printList = () => {
	// console.log(account.value)
	// console.log(startDate)
	// console.log(endDate)
	// 获取VXE-Table实例
	const xTable = journalTable.value;
	let headerHtml = `<h3>${account.value?.code}-${account.value?.name}日记账</h3>
			<div style="display:flex;justify-content: space-between;height:22px;line-height:22px">
				<span> </span>
				<span>${startDate.value}期 至 ${endDate.value}期</span>
				<span> 单位：元 </span>
			</div>
			`;
	let footerHtml = `<div style="display:flex;justify-content: left;;height:22px;line-height:22px">编制单位：${store.state.currentAccountSets.companyName}</div>`;
	let columns = [
		{ field: 'code' },
		{ field: 'serialNumber' },
		{ field: 'billDate' },
		{ field: 'digest' },
		{ field: 'ioTypeValue' },
		{ field: 'accountingCategoryDetailsValue' },
		// { field: 'deptName' },
		// { field: 'projectName' },
		{ field: 'debit' },
		{ field: 'credit' },
		{ field: 'balance' },
		{ field: 'billNo' },
		{ field: 'remark' },
	]
	if(showAll.value){columns.splice(6,0,{ field: 'projectName' })}
	if(showAll.value){columns.splice(6,0,{ field: 'deptName' })}
	if (xTable) {
    xTable.print({	 	
      // 打印样式设置
      style: tablePrint,
      // 打印指定列
      columns:columns,
      // 打印之前拼接自定义模板
      beforePrintMethod: ({ content }) => {
		if(showAll.value){columns.push({ field: 'deptName' });columns.push({ field: 'projectName' });}
        // 打印之前，返回自定义的 html 内容
        return headerHtml + content + footerHtml
      }
    })
  }
}

const exportJournal = () => {
	// window.open("/api/cashier/journal/download/" + account.value.id + "?" + Qs.stringify(Object.assign(params, page.value)))
	const $table = journalTable.value
	let arr = ["code",'serialNumber','billDate','digest','ioTypeValue','accountingCategoryDetailsValue','debit','credit','balance','billNo','remark']
	if(showAll.value){arr.splice(6,0,'projectName')}
	if(showAll.value){arr.splice(6,0,'deptName')}
	if ($table) {
		$table.exportData({
			filename: `${account.value?.code}-${account.value?.name}日记账`,
			type: 'csv',
			columnFilterMethod ({ column }) {
				return arr.includes(column.field)
			}
		})
	}
}

const importJournal = () => {
	let layerId = layer.open({
		title: account.value.name + "日记账导入",
		shadeClose: false,
		closeBtn: false,
		zIndex: 1000,
		area: ['500px', 'auto'],
		content: h(CashierImport, {
			account: account.value,
			ioType: ioType.value,
			onClose: () => {
				loadList();
				layer.close(layerId);
			},
			onSuccess: () => {
				loadList();
				layer.close(layerId);
			}
		})
	});
}

const importJournalWithMapping = () => {
	let layerId = layer.open({
		title: account.value.name + "银行对账单导入",
		shadeClose: false,
		closeBtn: false,
		zIndex: 1000,
		area: ['700px', '85%'],
		content: h(CashierImportMapping, {
			account: account.value,
			ioType: ioType.value,
			onClose: () => {
				loadList();
				layer.close(layerId);
			},
			onSuccess: () => {
				loadList();
				layer.close(layerId);
			}
		})
	});
}

const batchClickItem = (type) => {
	let recordsCheck = journalTable.value.getCheckboxRecords();
	let records = journalTable.value.getCheckboxRecords().map(row => row.id);
	if (records.length) {
		switch (type) {
			case 'batchDelete':
				confirm({
					content: `确认删除这些记录?`,
					onConfirm: () => {
						if (recordsCheck.length && recordsCheck.every(val => !val.voucherId)){
							loading.value = true;
							CashierJournal.batchDelete(records).then(() => {
								loadList();
							}).finally(() => loading.value = false)
						}else{
							message("选择的记录包含已经生成的凭证的，如需删除，请先删除凭证后再试！")
						}
					}
				})
				break
			case 'setIoType':
			case 'setAccountingCategory':
			case 'setProject':
			case 'setDept':
				if (recordsCheck.length && recordsCheck.every(val => !val.voucherId)){
					let layerId = layer.open({
						title: "批量更新",
						shadeClose: false,
						closeBtn: false,
						area: ['400px', 'auto'],
						zIndex: 1000,
						content: h(CashierJournalBatchUpdate, {
							records, type, ioTypeOptions,
							ioTypeMap, settlementTypeOptions, deptOptions, projectOptions,
							onClose: () => {
								layer.close(layerId);
							},
							onSuccess: () => {
								loadList();
								layer.close(layerId);
							}
						})
					});
					break
				}else{
					message("选择的记录包含已经生成的凭证的，如需修改，请先删除凭证后再试！")
				}
		}
	} else {
		message("请选择需要操作的记录~")
	}
}

const voucherClickItem = (key) => {
	if (key === 'generatePreview') {
		//jxd 生成凭证，整行的单据信息
		let records = journalTable.value.getCheckboxRecords();
		// jxd account.value当前账户信息
		// console.log(records,account.value)
		if (records.length && records.every(val => !val.voucherId)) {
			if (account.value.subjectId) {
				let layerId = layer.drawer({
					title: account.value.name + " 凭证预览",
					zIndex: 999,
					area: ['1200px', '100vh'],
					content: h(CashierJournalVoucherPreview, {
						records, account: account.value,deptOptions, projectOptions,assistingAccountingAll,//部门项目传过去9985
						onClose: () => {
							// loadList();
							layer.close(layerId);
						},
						onSuccess: () => {
							layer.close(layerId);
							loadList();
						}
					})
				});
			} else {
				confirm({
					content: `账户【${account.value.name}】未设置会计科目<br>不能生成预览凭证<br>是否立即设置?`,
					okText: "立即设置",
					cancelText: "稍后操作",
					onConfirm() {
						let layerId = layer.open({
							title: account.value.name + " 账户信息",
							shadeClose: false,
							closeBtn: false,
							zIndex: 1000,
							area: ['400px', 'auto'],
							content: h(CashierAccountForm, {
								entity: account.value,
								type: account.value.type,
								onClose: () => {
									layer.close(layerId);
								},
								onSuccess: () => {
									loadAccountList();
									layer.close(layerId);
								}
							})
						});
					}
				})
			}
		} else {
			message("没有选择需生成凭证的记录或选择的记录已经生成凭证~")
		}
	} else if (key === 'generateSettings') {
		let layerId = layer.drawer({
			title: ioType.value + "凭证模板",
			zIndex: 1000,
			area: ['700px', '100vh'],
			content: h(CashierIoTypeTemplate, {
				ioType, account,
				onClose: () => {
					layer.close(layerId);
				},
				onSuccess: () => {
					layer.close(layerId);
				}
			})
		});
	}
}

watch(account, () => {
	loadList();
})

watch(ioType, () => {
	account.value = null;
	loadAccountList();
})

watch(showAll, () => {
	setTimeout(() => {
		journalTable.value.refreshColumn();
	}, 200)
})
</script>
